import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
// theme
import { bgBlur } from 'src/theme/css';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Logo from 'src/components/logo';
import ThemeModeButton from 'src/components/ThemeModeButton';
import UserInfo from 'src/components/UserInfo';
import LogoutButton from 'src/components/LogoutButton';
import { useAuthContext } from 'src/auth/hooks';
import { HEADER } from '../config-layout';
import HeaderShadow from './header-shadow';

// ----------------------------------------------------------------------

export default function HeaderSimple({ title, disabled }) {
  const theme = useTheme();
  const { user } = useAuthContext();

  const userInfoRender = user && !disabled && (
    <Stack direction="row" spacing={2}>
      <UserInfo sx={{ textAlign: 'right' }} />
      <LogoutButton />
      <ThemeModeButton />
    </Stack>
  );

  return (
    <AppBar>
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: { xs: HEADER.H_MOBILE, md: HEADER.H_DESKTOP_OFFSET },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...bgBlur({ color: theme.palette.background.paper }),
        }}
      >
        <Box sx={{ pointerEvents: disabled ? 'none' : 'auto' }}>
          <Logo isFull />
        </Box>
        {title && (
          <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>
            {title}
          </Typography>
        )}
        {userInfoRender}
      </Toolbar>

      <HeaderShadow />
    </AppBar>
  );
}

HeaderSimple.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
};
